import React, { PureComponent } from 'react';
import { Marker } from 'react-map-gl';
import ShapeOfTypes from '../../../utils/ShapeOfTypes';
import { ReactComponent as IconPin } from '../../../assets/svg/map-pin.svg';
import { mapData } from './MapConfig';

export default class PinMarker extends PureComponent {
  render() {
    const { address, mapRef } = this.props;

    if (address?.lat && address?.lng) {
      if (mapRef.current) {
        mapRef.current.easeTo({ center: [address.lng, address.lat], zoom: mapData.zoomLevel.pin });
      }
  
      return (
        <Marker
          captureDrag={false}
          key={address.address}
          latitude={address.lat}
          longitude={address.lng}
        >
          <div className="pin-icon">
            <IconPin className="confirm__pin-icon" role="img" />
          </div>
        </Marker>
      );
    }
    return null;
  }
}
PinMarker.propTypes = {
  address: ShapeOfTypes.Address,
};
PinMarker.defaultProps = {
  address: {},
};